```vue
<template>
  <div>
    <!-- Botón Registrar Firma -->
    <v-btn
      v-if="!formData || (formData && formData.EstadoFormulario != '3')"
      color="#c62828"
      size="x-large"
      @click="abrirDialogo"
    >
      Registrar firma
    </v-btn>

    <!-- Dialog -->
    <v-dialog v-model="dialog" max-width="600px">
      <v-card>
        <v-card-title class="text-white" style="background-color: #c62828">
          Firma del responsable
        </v-card-title>

        <v-card-text>
          <!-- Selección del tipo de firma -->
          <v-tabs v-model="tipoFirma" color="#c62828" grow class="mb-4">
            <v-tab value="dibujar"> Dibujar firma </v-tab>

            <v-tab value="subir"> Subir firma </v-tab>
          </v-tabs>

          <v-window v-model="tipoFirma">
            <!-- ========================== -->
            <!-- FIRMA DIBUJADA -->
            <!-- ========================== -->
            <v-window-item value="dibujar">
              <div class="mb-2">
                <strong>Dibuje su firma</strong>
              </div>

              <vue-signature-pad
                ref="signaturePad"
                :options="options"
                class="firma-canvas"
              />
            </v-window-item>

            <!-- ========================== -->
            <!-- FIRMA DESDE ARCHIVO -->
            <!-- ========================== -->
            <v-window-item value="subir">
              <div class="mb-2">
                <strong>Seleccione una imagen de su firma</strong>
              </div>

              <v-file-input
                v-model="archivoFirma"
                label="Seleccionar firma"
                accept="image/png,image/jpeg,image/jpg,image/webp"
                prepend-icon="mdi-image"
                variant="outlined"
                show-size
                clearable
                @update:model-value="cargarFirmaImagen"
              />

              <!-- Vista previa -->
              <div v-if="firmaImagenBase64" class="firma-preview-container mt-4">
                <v-img
                  :src="firmaImagenBase64"
                  max-width="300"
                  max-height="180"
                  contain
                  class="firma-preview"
                />
              </div>
            </v-window-item>
          </v-window>
        </v-card-text>

        <v-card-actions class="justify-between px-4 pb-4">
          <v-btn variant="outlined" @click="limpiarFirma"> Limpiar </v-btn>

          <div>
            <v-btn variant="tonal" @click="dialog = false"> Cancelar </v-btn>

            <v-btn color="primary" @click="guardarFirma"> Guardar </v-btn>
          </div>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <!-- Firma capturada -->
    <div v-if="firmaBase64 || modelValue" class="mt-4">
      <strong>Firma capturada:</strong>

      <v-img
        :src="firmaBase64 || modelValue"
        max-width="150"
        max-height="100"
        contain
        class="mt-1 rounded"
      />
    </div>
  </div>
</template>

<script setup>
import { ref } from "vue";
import { VueSignaturePad } from "vue-signature-pad";

// ==============================
// PROPS & EMITS
// ==============================

const props = defineProps({
  formData: {
    type: Object,
    default: () => ({}),
  },

  modelValue: {
    type: String,
    default: "",
  },
});

const emit = defineEmits(["update:modelValue"]);

// ==============================
// VARIABLES
// ==============================

const dialog = ref(false);

const signaturePad = ref(null);

const firmaBase64 = ref("");

const tipoFirma = ref("dibujar");

// Archivo seleccionado
const archivoFirma = ref(null);

// Imagen convertida a Base64
const firmaImagenBase64 = ref("");

// ==============================
// CONFIGURACIÓN SIGNATURE PAD
// ==============================

const options = {
  penColor: "black",
  backgroundColor: "white",
};

// ==============================
// ABRIR DIALOG
// ==============================

function abrirDialogo() {
  dialog.value = true;
}

// ==============================
// CARGAR IMAGEN DE FIRMA
// ==============================

function cargarFirmaImagen(file) {
  firmaImagenBase64.value = "";

  if (!file) {
    return;
  }

  /*
   * Dependiendo de la versión de Vuetify,
   * puede llegar directamente File o un Array.
   */
  const archivo = Array.isArray(file) ? file[0] : file;

  if (!archivo) {
    return;
  }

  // Validar que realmente sea una imagen
  if (!archivo.type.startsWith("image/")) {
    console.error("El archivo seleccionado no es una imagen.");
    archivoFirma.value = null;
    return;
  }

  const reader = new FileReader();

  reader.onload = (event) => {
    firmaImagenBase64.value = event.target.result;

    console.log("Firma cargada en Base64:", firmaImagenBase64.value);
  };

  reader.onerror = () => {
    console.error("No fue posible leer la imagen.");
    firmaImagenBase64.value = "";
  };

  reader.readAsDataURL(archivo);
}

// ==============================
// LIMPIAR FIRMA
// ==============================

function limpiarFirma() {
  // Limpiar canvas
  if (signaturePad.value) {
    signaturePad.value.clearSignature();
  }

  // Limpiar archivo
  archivoFirma.value = null;

  // Limpiar imagen Base64
  firmaImagenBase64.value = "";

  // Limpiar firma guardada
  firmaBase64.value = "";

  // Limpiar también en el padre
  emit("update:modelValue", "");
}

// ==============================
// GUARDAR FIRMA
// ==============================

function guardarFirma() {
  // ------------------------------
  // OPCIÓN 1: FIRMA DIBUJADA
  // ------------------------------

  if (tipoFirma.value === "dibujar") {
    if (!signaturePad.value) {
      return;
    }

    const respuestaBase64 = signaturePad.value.saveSignature();

    firmaBase64.value = respuestaBase64.data;
  }

  // ------------------------------
  // OPCIÓN 2: FIRMA SUBIDA
  // ------------------------------

  if (tipoFirma.value === "subir") {
    if (!firmaImagenBase64.value) {
      console.warn("Debe seleccionar una imagen de firma.");
      return;
    }

    firmaBase64.value = firmaImagenBase64.value;
  }

  // ------------------------------
  // ACTUALIZAR PADRE
  // ------------------------------

  console.log("Firma final en Base64:", firmaBase64.value);

  emit("update:modelValue", firmaBase64.value);

  dialog.value = false;
}
</script>

<style scoped>
.firma-canvas {
  border: 1px solid #ccc;
  border-radius: 6px;
  width: 100%;
  height: 200px;
}

.firma-preview-container {
  border: 1px dashed #ccc;
  border-radius: 6px;
  padding: 15px;
  display: flex;
  justify-content: center;
  align-items: center;
  min-height: 150px;
}

.firma-preview {
  width: 100%;
}
</style>
```
